import React, { useEffect, useRef, useState } from 'react'
import { navList } from '../../config/docFile'
import { Link, useLocation } from 'react-router-dom'
import { useDrawerTransition } from '../../context/drawerProvider'
import '../../index.css'
import { useDispatch, useSelector } from 'react-redux'
import Lang from '../../config/lang'
import { clearSession, isSessionExpired, isStageUrl } from '../../config/helper'
import { setIsLogin, setUserName } from '../../redux/actions/language'
import { loadCurrentApplicantProfile } from '../../config/applicantApi'

const Navbar = ({ mobileView = false }) => {
  const { lang, isLogin, name } = useSelector((state) => state.globalReducer)
  const dispatch = useDispatch()
  const [openList, setOpenList] = useState(false)
  const [isDropdown, setIsDropdown] = useState(false)
  const location = useLocation()
  const isActive = (path) => location.pathname === path
  const { startTransition } = useDrawerTransition()
  const navbarRef = useRef(null)
  const dropdownRef = useRef(null)
  const scrollIdleTimeoutRef = useRef(null)
  let lastScrollTop = useRef(0)

  const applicantID = localStorage?.getItem('applicantID')
  const userToken = localStorage?.getItem('authToken') || ''

  const checkExpiryLogin = async () => {
    if (
      isSessionExpired() ||
      (window.location.href.includes('Profile') && !applicantID)
    ) {
      clearSession()
      dispatch(setIsLogin(false))
      startTransition(`/${lang}`)
    }
  }

  const [profileData, setprofileData] = useState('')

  const loadApplicant = async () => {
    const resData = await loadCurrentApplicantProfile({ userToken })

    if (resData) {
      setprofileData(resData)
      dispatch(setUserName(resData.fullName))
    }
  }
  useEffect(() => {
    checkExpiryLogin()
    const is_login = localStorage?.getItem('isLogin')
    if (is_login && userToken) {
      loadApplicant()
    }
    dispatch(setIsLogin(is_login))
  }, [])

  useEffect(() => {
    if (navbarRef.current) {
      navbarRef.current.style.transform = mobileView
        ? 'translateY(0)'
        : 'translateY(36%)'
    }

    if (scrollIdleTimeoutRef.current) {
      clearTimeout(scrollIdleTimeoutRef.current)
      scrollIdleTimeoutRef.current = null
    }

    lastScrollTop.current = 0
    setOpenList(false)
    setIsDropdown(false)

    if (mobileView) return

    const handleScroll = () => {
      if (!navbarRef.current) return

      const scrollTop = document.documentElement.scrollTop
      if (scrollTop > lastScrollTop.current) {
        navbarRef.current.style.transform = 'translateY(-100%)'
      } else {
        navbarRef.current.style.transform = 'translateY(36%)'
      }

      if (scrollIdleTimeoutRef.current) {
        clearTimeout(scrollIdleTimeoutRef.current)
      }

      scrollIdleTimeoutRef.current = setTimeout(() => {
        if (navbarRef.current) {
          navbarRef.current.style.transform = 'translateY(36%)'
        }
      }, 220)

      lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)

      if (scrollIdleTimeoutRef.current) {
        clearTimeout(scrollIdleTimeoutRef.current)
        scrollIdleTimeoutRef.current = null
      }
    }
  }, [mobileView])

  useEffect(() => {
    const is_login = localStorage?.getItem('isLogin')
    const authToken = localStorage?.getItem('authToken') || ''

    if (is_login && authToken) {
      loadApplicant()
    }

    dispatch(setIsLogin(is_login))
    setIsDropdown(false)
    setOpenList(false)
  }, [location.pathname])

  useEffect(() => {
    if (!isDropdown) return

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdown(false)
      }
    }

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isDropdown])

  function getInitials(name) {
    if (!name) return ''
    const parts = name.trim().split(/\s+/)

    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase()
    }

    const first = parts[0][0]
    const last = parts[parts.length - 1][0]
    return (first + last).toUpperCase()
  }
  return !mobileView ? (
    <nav
      id='navbar'
      ref={navbarRef}
      className={
        (location.pathname.includes('login')
          ? 'fixed mx-auto inset-x-0 '
          : 'sticky ') +
        'glass-card block px-2 py-[15px] rounded-full w-[95%] max-w-[1296px] top-[.1px] transition-transform duration-100'
      }
      style={{
        boxShadow: '0px 1px 2px rgba(0,0,0,0.05)',
        margin: '0 auto',
        transform: 'translateY(36%)',
        zIndex: 100,
      }}
    >
      <div className='flex flex-row items-center justify-between font-medium text-[15px]'>
        <a
          className='w-[15%] pl-5'
          href={
            isStageUrl()
              ? 'https://stage.solusi-pack.com/en/compro/sopra'
              : 'https://solusi-pack.com/en'
          }
        >
          <img src='/asset/logosopra_high.png' />
        </a>
        {navList
          ?.filter((obj) => obj?.show === true)
          ?.map((value, idx) => (
            // <Link to={value?.path} className={`hover:text-[#034694] cursor-pointer transition-[1s] ${isActive(value?.path) ? 'text-[#034694] font-bold' : 'font-bold'}`} key={idx}>{value.label}</Link>
            <a
              href={`/${lang}/${value?.path}`}
              key={idx}
              className='nav-item cursor-pointer'
              onClick={(e) => {
                e.preventDefault()
                startTransition(`/${lang}/${value?.path}`)
              }}
            >
              <div className='nav-content'>
                <p
                  className={`nav-text text-[15px] 2xl:text-[17px] ${isActive(`/${lang}/${value?.path}`) ? 'text-[#034694] font-bold' : 'font-bold'}`}
                >
                  {Lang(lang, value.label)}
                </p>
                <p className='nav-text text-[15px] 2xl:text-[17px]'></p>
                <p
                  className={`nav-text text-[15px] 2xl:text-[17px] ${isActive(`/${lang}/${value?.path}`) ? 'text-[#034694] font-bold' : 'font-bold'}`}
                >
                  {Lang(lang, value.label)}
                </p>
              </div>
            </a>
          ))}
        <div ref={dropdownRef} className='relative flex flex-col items-end'>
          <a
            href={`/${lang}/login`}
            className={
              (isActive(`/${lang}/login`)
                ? 'text-[#034694] font-bold border-[#034694] '
                : 'text-[#48494B] border-[#A1A1A1] ') +
              `border hover:bg-white hover:text-[#000000] rounded-full py-1 px-3 transition-[1s] font-bold md:mr-2`
            }
            onClick={(e) => {
              e.preventDefault()

              const is_login = localStorage?.getItem('isLogin')
              if (is_login) {
                if (isDropdown) {
                  setIsDropdown(false)
                } else {
                  setIsDropdown(true)
                }
              } else {
                startTransition(`/${lang}/login`)
              }
            }}
          >
            {isLogin ? (
              <div className='h-[25px] flex flex-row items-center justify-center'>
                <div className='relative w-[20px] h-[20px] rounded-full overflow-hidden'>
                  <img
                    src='/asset/images/profile_bg.png'
                    alt='profile background'
                    className='object-cover w-full h-full'
                  />

                  <div className='absolute inset-0 flex items-center justify-center'>
                    <span className='text-white text-[10px] mt-[0.5px] font-bold'>
                      {getInitials(name || profileData.fullName)}
                    </span>
                  </div>
                </div>
                <img
                  className='w-[20px]'
                  src={
                    isDropdown
                      ? '/asset/icon/arrow_down.svg'
                      : '/asset/icon/arrow_right.svg'
                  }
                  alt=''
                />
              </div>
            ) : (
              Lang(lang, 'login')
            )}
          </a>

          {isDropdown && (
            <div className='glass-card-dropdown absolute right-0 top-[calc(100%+10px)] z-[9999] w-[208px] rounded-[16px] p-1.5'>
              <a
                href={`/${lang}/profile`}
                onClick={(e) => {
                  e.preventDefault()
                  setIsDropdown(false)
                  startTransition(`/${lang}/profile`)
                }}
                className='flex items-center gap-2.5 rounded-[12px] px-2.5 py-2.5 text-[#334155] transition hover:bg-[#F8FAFC]'
              >
                <span className='flex h-8 w-8 items-center justify-center rounded-[9px] bg-[#F8FAFC]'>
                  <img
                    className='h-4 w-4'
                    src='/asset/icon/profile_dark.svg'
                    alt=''
                  />
                </span>
                <span className='text-[14px] font-semibold leading-5'>
                  {Lang(lang, 'profile')}
                </span>
              </a>

              <a
                href={`/${lang}/my-application`}
                onClick={(e) => {
                  e.preventDefault()
                  setIsDropdown(false)
                  startTransition(`/${lang}/my-application`)
                }}
                className='flex items-center gap-2.5 rounded-[12px] px-2.5 py-2.5 text-[#334155] transition hover:bg-[#F8FAFC]'
              >
                <span className='flex h-8 w-8 items-center justify-center rounded-[9px] bg-[#F8FAFC]'>
                  <img
                    className='h-4 w-4'
                    src='/asset/icon/document.svg'
                    alt=''
                  />
                </span>
                <span className='text-[14px] font-semibold leading-5'>
                  {Lang(lang, 'my_application')}
                </span>
              </a>

              <div className='my-1.5 h-px bg-[#E5E7EB]' />
              <a
                href={`/${lang}/login`}
                onClick={(e) => {
                  e.preventDefault()
                  setIsDropdown(false)
                  dispatch(setIsLogin(false))
                  clearSession()
                }}
                className='flex items-center gap-2.5 rounded-[12px] px-2.5 py-2.5 text-[#EA2427] transition hover:bg-[#FFF1F2]'
              >
                <span className='flex h-8 w-8 items-center justify-center rounded-[9px] bg-[#FFF1F2]'>
                  <img
                    className='h-4 w-4'
                    src='/asset/icon/logout.svg'
                    alt=''
                  />
                </span>
                <span className='text-[14px] font-semibold leading-5'>
                  {Lang(lang, 'logout')}
                </span>
              </a>
            </div>
          )}
        </div>
        <a
          href={`/${lang}/portal`}
          className='bg-[#EA2427] text-white border border-[#EA2427] hover:bg-white hover:text-[#EA2427] rounded-full py-1 px-3 transition-[1s] font-bold md:mr-2'
          onClick={(e) => {
            e.preventDefault()
            startTransition(`/${lang}/portal`)
          }}
        >
          {Lang(lang, 'explore_jobs')}
        </a>
      </div>
    </nav>
  ) : (
    <nav
      id='navbar'
      ref={navbarRef}
      className='glass-card px-4 py-[12px] rounded-b-[15px] w-full fixed'
      style={{
        boxShadow: '0px 1px 2px rgba(0,0,0,0.05)',
        margin: '0 auto',
        zIndex: 9999,
      }}
    >
      <div className='flex flex-row items-center justify-between font-medium px-4'>
        <a
          className='w-[38%]'
          href={
            isStageUrl()
              ? 'https://stage.solusi-pack.com/en/compro/sopra'
              : 'https://solusi-pack.com/en'
          }
        >
          <img src='/asset/logosopra_high.png' />
        </a>
        <a className='w-[10%]' onClick={() => setOpenList(!openList)}>
          <img
            src={openList ? '/asset/icon/close.svg' : '/asset/icon/menu.png'}
          />
        </a>
      </div>

      {/* Animated container */}
      <div
        className={`
                    transition-all duration-300 ease-in-out overflow-hidden
                    ${openList ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}
                `}
      >
        <div className='flex flex-col gap-[13px] font-medium text-[14px] pt-8 pb-6 px-4'>
          {navList
            ?.filter((obj) => obj?.show === true)
            ?.map((value, idx) => (
              <a
                href={`/${lang}/${value?.path}`}
                className={`${isActive(value?.path) ? 'text-[#034694]' : 'text-[#48494B]'} font-bold`}
                key={idx}
                onClick={(e) => {
                  e.preventDefault()
                  startTransition(`/${lang}/${value?.path}`)
                  setOpenList(!openList)
                }}
              >
                {Lang(lang, value.label)}
              </a>
            ))}

          {isLogin ? (
            <div className='gap-2 flex flex-col'>
              <a
                href={`/${lang}/profile`}
                onClick={(e) => {
                  e.preventDefault()
                  setIsDropdown(false)
                  setOpenList(false)
                  startTransition(`/${lang}/profile`)
                }}
                className='flex flex-row items-center gap-2 text-[#48494B] font-bold'
              >
                <img
                  className='h-4 w-4 shrink-0'
                  src='/asset/icon/profile.svg'
                  alt=''
                />
                {Lang(lang, 'profile')}
              </a>
              <a
                href={`/${lang}/my-application`}
                onClick={(e) => {
                  e.preventDefault()
                  setIsDropdown(false)
                  setOpenList(false)
                  startTransition(`/${lang}/my-application`)
                }}
                className='flex flex-row items-center gap-2 text-[#48494B] font-bold '
              >
                <img
                  className='h-4 w-4 shrink-0'
                  src='/asset/icon/document.svg'
                  alt=''
                />
                {Lang(lang, 'my_application')}
              </a>
              <div className='h-[.5px] bg-[#D1D5DB] my-1' />
              <a
                href={`/${lang}/login`}
                onClick={(e) => {
                  setIsDropdown(false)
                  setOpenList(false)
                  dispatch(setIsLogin(false))
                  localStorage?.removeItem('isLogin')
                  localStorage?.removeItem('applicantID')
                }}
                className='flex flex-row items-center gap-2 text-[#EA2427] font-bold'
              >
                <img
                  className='h-4 w-4 shrink-0'
                  src='/asset/icon/logout.svg'
                  alt=''
                />
                {Lang(lang, 'logout')}
              </a>
            </div>
          ) : (
            <a
              href={``}
              style={{ position: 'relative' }}
              className={
                (isActive(`/${lang}/login`)
                  ? 'text-[#034694] font-bold border-[#034694] '
                  : 'text-[#48494B] border-[#A1A1A1] ') +
                `border hover:bg-white hover:text-[#000000] rounded-full py-1 px-3 transition-[1s] font-bold md:mr-2`
              }
              onClick={(e) => {
                e.preventDefault()
                startTransition(`/${lang}/login`)
              }}
            >
              {Lang(lang, 'login')}
            </a>
          )}
          <Link
            to={`/${lang}/portal`}
            className='bg-[#EA2427] text-white rounded-full py-1 mt-2 px-6 w-fit'
            onClick={() => setOpenList(!openList)}
          >
            {Lang(lang, 'explore_jobs')}
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
